import { faUserCircle } from "@fortawesome/pro-regular-svg-icons";

import { ReviewCaseStatus as ReviewCaseStatusType } from "src/api/types";
import { Icon } from "src/design-system/Icon";

export const ReviewCaseStatus: React.FC<{ status: ReviewCaseStatusType }> = ({
  status,
}) => {
  return (
    <div className="flex items-center gap-1 overflow-hidden pr-2">
      <Icon
        variant={status === "needs_review" ? "active" : "success"}
        icon={faUserCircle}
        size="xs"
      />
      <span className="truncate">
        {status === "needs_review"
          ? "Needs manual review"
          : "Review in Progress"}
      </span>
    </div>
  );
};
